import { Box, FormControl, IconButton, InputLabel, ListSubheader, MenuItem, Select, Stack, TextField, Tooltip, Typography } from "@mui/material"
import { useState, useEffect } from "react"

import { convertDbNumberToHtml } from "../../../common/Helper"
import FilterHelper from '../common/FieldsHelper'

import HelpOutlineIcon from '@mui/icons-material/HelpOutline'

const FilterParameter = (props) => {

	const { fields, filterClauses }					= props

	const [selectedParameter, setSelectedParameter]	= useState()
	const [field, setField]							= useState(props.field || '')
	const [operation, setOperation]					= useState(props.operation || '')
	const [parameter, setParameter]					= useState(props.parameter)
	const [isFieldOpen, setIsFieldOpen]				= useState(false)

	let requiredParameter

	useEffect(() => {
		const settings = {
			field 		: field,
			operation 	: operation,
			parameter 	: parameter
		}

		if (props.onChange) props.onChange(settings)
	}, [field, operation, parameter])

	useEffect(() => {
		if (fields) setSelectedParameter(fields.find(f => f.id === field))
	}, [fields])

	const handleNumericInput = (value) => {
		setParameter(value.replace(/[^0-9,]|,(?=.*,)/g,''))
	}

	if (selectedParameter?.requiredField) {
		// Procura se o pai foi setado
		const parentParameter = filterClauses.find(f => f.field === selectedParameter?.requiredField)
		requiredParameter = parentParameter?.parameter
	}

	let currentCategory

	return (
		<Stack direction="row" spacing={1}  width={'100%'} display={'flex'}>
			<FormControl sx={{width: 160}} {...props.error ? {error : true} : null}>
				<InputLabel>Campo</InputLabel>
				<Select 
					label="Campo" 
					value={field} 
					onOpen={() => setIsFieldOpen(true)}
					onClose={() => setIsFieldOpen(false)}
					onChange={(e) => {
						setField(e.target.value)
						setOperation('')
						setParameter('')
					}}>
					{fields && fields.map(f => {
						let currentItems = []

						if (currentCategory !== f.category) {
							currentCategory = f.category
							currentItems.push(<ListSubheader>{f.categoryDescription}</ListSubheader>)
						}

						currentItems.push(
							<MenuItem value={f.id} selected={f.id === field ? true : false}>
								<span style={{ flex: 1 }}>{f.label}</span>
								{isFieldOpen && f.description && (
									<Tooltip title={f.description}>
										<IconButton size="small" sx={{ ml: 1 }}>
										<HelpOutlineIcon fontSize="small" />
										</IconButton>
									</Tooltip>
								)}
							</MenuItem>
						)

						return currentItems
					})}
				</Select>
			</FormControl>

			{ selectedParameter && selectedParameter.type === 'numeric' ? (
				<Stack direction= 'row' spacing={1} width={'100%'} display={'flex'} flex={1}>
					<FormControl sx={{width: 160}} {...props.error ? {error : true} : null}>
						<InputLabel>Operação</InputLabel>
						<Select label="Operação" value={operation} onChange={(e) => setOperation(e.target.value)}>
							<MenuItem value="lt">Menor que</MenuItem>
							<MenuItem value="le">Menor ou igual a</MenuItem>
							<MenuItem value="eq">Igual a</MenuItem>
							<MenuItem value="ge">Maior ou igual a</MenuItem>
							<MenuItem value="gt">Maior que </MenuItem>
						</Select>
					</FormControl>
					<Box flex={1}>
						<TextField 
							label="Valor" 
							value={convertDbNumberToHtml(parameter)} 
							fullWidth 
							onChange={(e) => handleNumericInput(e.target.value)}
							inputProps={{ maxLength: 20 }}
							{...props.error ? {error : true} : null}
						/>
					</Box>
				</Stack>
			) : selectedParameter && selectedParameter.type === 'text' ? (
				<Stack direction= 'row' spacing={1} width={'100%'} display={'flex'} flex={1}>
					<FormControl sx={{width: 160}} {...props.error ? {error : true} : null}>
						<InputLabel>Operação</InputLabel>
						<Select label="Operação" value={operation} onChange={(e) => setOperation(e.target.value)}>
							<MenuItem value="ct">Contém</MenuItem>
							<MenuItem value="nc">Não Contém</MenuItem>
						</Select>	
					</FormControl>
					<Box flex={1}>
						<TextField 
							label="Valor" 
							value={parameter} 
							fullWidth 
							onChange={(e) => setParameter(e.target.value)}
							inputProps={{ maxLength: 50 }}
							{...props.error ? {error : true} : null}
						/>
					</Box>
				</Stack>
			) : selectedParameter && selectedParameter.type === 'boolean' ? (
				<Stack direction= 'row' spacing={1} width={'100%'} display={'flex'} flex={1}>
					<FormControl sx={{width: 160}} {...props.error ? {error : true} : null}>
						<InputLabel>Operação</InputLabel>
						<Select label="Operação" value={operation} onChange={(e) => setOperation(e.target.value)}>
							<MenuItem value="eq">Igual a</MenuItem>
							<MenuItem value="ne">Diferente de</MenuItem>
						</Select>	
					</FormControl>
					<Box flex={1}>
						<FormControl fullWidth>
							<InputLabel>Valor</InputLabel>
							<Select label="Valor" value={parameter} onChange={(e) => setParameter(e.target.value)}>
								<MenuItem value={0}>Sim</MenuItem>
								<MenuItem value={1}>Não</MenuItem>
							</Select>
						</FormControl>
					</Box>
				</Stack>
			) : selectedParameter && selectedParameter.type === 'options' ? (
				<Stack direction= 'row' spacing={1} width={'100%'} display={'flex'} flex={1}>
					<FormControl sx={{width: 160}}>
						<InputLabel>Operação</InputLabel>
						{ selectedParameter.unit === 'array' ? (
							<Select label="Operação" value={operation} onChange={(e) => setOperation(e.target.value)}>
								<MenuItem value="in">Inclui</MenuItem>
								<MenuItem value="ni">Não Inclui</MenuItem>
							</Select>	
						) : selectedParameter.unit === 'number' ? (
							<Select label="Operação" value={operation} onChange={(e) => setOperation(e.target.value)} size={props.size || "medium"}>
								<MenuItem value="lt">{props.size === 'small' ? '<' : 'Menor que'}</MenuItem>
								<MenuItem value="le">{props.size === 'small' ? '≤' : 'Menor ou igual a'}</MenuItem>
								<MenuItem value="eq">{props.size === 'small' ? '=' : 'Igual a'}</MenuItem>
								<MenuItem value="ge">{props.size === 'small' ? '≥' : 'Maior ou igual a'}</MenuItem>
								<MenuItem value="gt">{props.size === 'small' ? '>' : 'Maior que '}</MenuItem>
							</Select>
						) : (
							<Select label="Operação" value={operation} onChange={(e) => setOperation(e.target.value)}>
								<MenuItem value="eq">Igual a</MenuItem>
								<MenuItem value="ne">Diferente de</MenuItem>
							</Select>	
						)}
					</FormControl>
					<Box flex={1} alignItems={'center'} display={'flex'}>
						{ selectedParameter.requiredField && !requiredParameter ? (
							<Typography color={'red'}>Você precisa incluir um valor para {selectedParameter.requiredField}</Typography>
						) : (
							<FormControl fullWidth>{FilterHelper.getOptionsComponent(selectedParameter.id, parameter, (value) => setParameter(value), requiredParameter)}</FormControl>
						)}
					</Box>
				</Stack>
			) : null}
		</Stack>
	)
}

export default FilterParameter